<app-dialog
  [visible]="visible"
  [width]="'640px'"
  [showHeader]="false"
  [closable]="true"
  (visibleChange)="visibleChange.emit($event)">
  <ng-container ngProjectAs="header">
    <div class="edit-modal__header">
      <h2>{{ "UPLOADED_GEO_IMAGES.EDIT_TITLE" | translate }}</h2>
      <p>{{ item?.title }}</p>
      <button
        class="modal-close-btn"
        type="button"
        (click)="handleCancel()">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </ng-container>
  <ng-container ngProjectAs="content">
    <div class="edit-modal__content">
      <div class="form-section">
        <label>{{ "UPLOADED_GEO_IMAGES.EDIT_TITLE_LABEL" | translate }}</label>
        <app-input
          [(ngModel)]="form.title"
          [placeholder]="'UPLOADED_GEO_IMAGES.MODAL_TITLE_PLACEHOLDER' | translate"></app-input>
      </div>
      <div class="form-section">
        <app-tag-selector
          [selectedTagIds]="form.tagIds"
          [label]="'UPLOADED_GEO_IMAGES.MODAL_TAGS'"
          [placeholder]="'UPLOADED_GEO_IMAGES.MODAL_TAGS_PLACEHOLDER'"
          [allowCreate]="true"
          (selectedTagIdsChange)="onTagIdsChange($event)"></app-tag-selector>
      </div>
      <div class="form-section">
        <label>{{ "UPLOADED_GEO_IMAGES.EDIT_DESCRIPTION_LABEL" | translate }}</label>
        <app-textarea
          [(ngModel)]="form.description"
          [placeholder]="'UPLOADED_GEO_IMAGES.EDIT_DESCRIPTION_PLACEHOLDER' | translate"
          [rows]="4"></app-textarea>
      </div>
    </div>
  </ng-container>
  <ng-container ngProjectAs="footer">
    <div class="edit-modal__footer">
      <app-secondary-button
        [width]="'140px'"
        [title]="'UPLOADED_GEO_IMAGES.MODAL_CANCEL' | translate"
        (action)="handleCancel()"></app-secondary-button>
      <app-save-button
        [width]="'140px'"
        [isSaving]="loading"
        [disabled]="!canSave"
        (save)="handleSave()"></app-save-button>
    </div>
  </ng-container>
</app-dialog>
